import { withAssetPrefix } from "gatsby";
import React, { useEffect, useState, useRef } from "react";
import { isMobile } from "react-device-detect";
import navUrls from "../navigationURLS.json";
import FlagCanada from "../static/images/flag-canada.jpg";
import FlagFrance from "../static/images/flag-france.jpg";
import FlagSpain from "../static/images/flag-spain.jpg";
import FlagUK from "../static/images/flag-uk.png";
import FlagUSA from "../static/images/flag-usa.jpg";
import HomeIcon1 from "../static/images/home-icon.png";
import HSLogo from "../static/images/homeserve-logo.svg";
import HomeIcon2 from "../static/images/hs-logo-inline.svg";
import SearchIcon from "../static/images/search-icon.png";
import { gtmFunction } from "./gtm";
import "./header.css";

const Header = ({ skipToSection = "main", isAssestPrefix = false, showAccessibilityToolbar = false, showCountrySelector = true, cludoSearchEnabled = false }) => {
  const isFirstClicked = useRef(false);
  // To disable the body scroll when offcanvas nav is open
  const [isMobNavOpen, setIsMobNavOpen] = useState(false);
  const offcanvasRef = useRef(null);
  const navBarRef = useRef(null);

  useEffect(() => {
    if (isMobNavOpen) {
      offcanvasRef.current.style.visibility = "visible";
      document.body.style.overflowY = "hidden";
      document.body.style.height = '100%';
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.height = '100%';
    } else {
      offcanvasRef.current.style.visibility = "hidden";
      document.documentElement.style.overflow = "hidden auto";
      document.body.style.overflow = "hidden auto";
      document.documentElement.style.maxHeight = '100%';
      document.body.style.maxHeight = '100%';
    }
  }, [isMobNavOpen])


  useEffect(() => {
    if (typeof window !== 'undefined' && cludoSearchEnabled && window.Cludo) {
      const cludoSettings = {
        customerId: 563,
        engineId: `${process.env.CLUDO_ENG_ID}`,
        searchUrl: `${process.env.GATSBY_BASE_URL}/search`,
        searchInputs: ['#cludo-search-form', '#cludo-search-form-mobile', '#cludo-search-form-help'],
        language: 'en',
      }
      const CludoSearch = new window.Cludo(cludoSettings);
      CludoSearch.init();
    }
  }, [cludoSearchEnabled]);




  useEffect(() => {
    const handleAnchorClick = () => {
      if (offcanvasRef.current) {
        offcanvasRef.current.classList.remove("show"); // Remove the 'show' class
        offcanvasRef.current.style.visibility = "hidden"; // Hide offcanvas
        setIsMobNavOpen(false);
      }
    };
    // Select all anchor elements with a specific class inside the offcanvas
    const anchors = offcanvasRef.current?.querySelectorAll("a:not(.canvas-navi-link), button");
    anchors?.forEach((anchor) => anchor.addEventListener("click", handleAnchorClick));
    const navBar = document.getElementById("navbar-anchorId");
    navBar !== null && navBar.addEventListener("click", handleAnchorClick);
    return () => {
      anchors?.forEach((anchor) => anchor.removeEventListener("click", handleAnchorClick));
      navBar !== null && navBar.removeEventListener("click", handleAnchorClick);
    };
  }, []);

  useEffect(() => {
    // To handle bootstrap navigation open on hover
    document.addEventListener("mousemove", handleMouseMove);
    // To handle click event and toggle caret icon
    const navBar = document.getElementById("ddCanvasMenu");
    navBar !== null && navBar.addEventListener("click", handleNavBarClick);

    // To handle country select on click
    document.addEventListener("click", handleCountrySelect);

    // To handle country dropdown focus out
    const countrySelect = document.getElementById("selectCountry");
    const countrySubMenu = document.getElementById("selectCountrySubmenu");
    countrySubMenu?.addEventListener("focusout", handleCountrySubMenuFocusOut);
    countrySelect?.addEventListener("focusout", handleCountrySubMenuFocusOut);

    const deviceWidth = document.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);

      document.removeEventListener("click", handleCountrySelect);

      navBar !== null && navBar.removeEventListener("click", handleNavBarClick);

      countrySubMenu?.removeEventListener(
        "focusout",
        handleCountrySubMenuFocusOut
      );

      countrySelect?.removeEventListener(
        "focusout",
        handleCountrySubMenuFocusOut
      );

      deviceWidth !== undefined &&
        deviceWidth.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document
      .querySelectorAll(
        "a.dropdown-item-link, a.contact-us-link, a.canvas-dropdown-item-link, a.canvas-navi-link, a.color-black"
      )
      .forEach((item) => {
        item.addEventListener("click", async (event) => {
          item.removeEventListener("click", gtmFunction);
          isFirstClicked.current === false &&
            (await gtmFunction(event.target.href, event.target.innerText.replace(/&/g, "and")));
          isFirstClicked.current = true;
        });
      });

    document
      .querySelectorAll("a.navbar-brand")[0]
      .addEventListener("click", async () => {
        isFirstClicked.current === false &&
          (await gtmFunction(
            document.querySelector(".navbar-brand").href,
            "Home Icon"
          ));
        isFirstClicked.current = true;
      });
  });

  const [deviceWidth, setDeviceWidth] = useState(0);
  const handleResize = () => {
    setDeviceWidth(window.innerWidth);
  };

  const handleNavBarClick = (event) => {
    const element = event.target;

    if (element.classList.contains("nav-bar-icon-rotate")) {
      element.classList.remove("nav-bar-icon-rotate");
    } else {
      element.classList.add("nav-bar-icon-rotate");
    }
  };

  const handleCountrySubMenuFocusOut = (e) => {
    const submenu = document.getElementById("selectCountrySubmenu");
    const caretIcon = document.getElementById("caretIcon");

    if (
      (e.relatedTarget &&
        e.relatedTarget.parentElement &&
        e.relatedTarget.parentElement.parentElement &&
        e.relatedTarget.parentElement.parentElement.getAttribute("id") ===
        "selectCountrySubmenu") ||
      (e.relatedTarget &&
        e.relatedTarget.getAttribute("id") === "selectCountry")
    ) {
      submenu.classList.remove("d-none");
      caretIcon.classList.add("rotate-element-180");
    } else {
      submenu.classList.add("d-none");
      caretIcon.classList.remove("rotate-element-180");
    }
  };

  const handleCountrySelect = (event) => {
    const countrySelect = document.getElementById("selectCountry");
    const submenu = document.getElementById("selectCountrySubmenu");
    const caretIcon = document.getElementById("caretIcon");

    if (countrySelect?.contains(event.target)) {
      if (submenu.classList.contains("d-none")) {
        submenu.classList.remove("d-none");
        caretIcon.classList.add("rotate-element-180");
      } else {
        submenu.classList.add("d-none");
        caretIcon.classList.remove("rotate-element-180");
      }
    } else {
      submenu?.classList.add("d-none");
      caretIcon?.classList.remove("rotate-element-180");
    }
  };

  const handleMouseMove = (event) => {
    const topLevelDD = document.getElementById("ddMenu");

    // On tab and mobile click event will work
    if (window.screen.width < 1280) return;

    if (topLevelDD.contains(event.target)) {
      if (event.target.parentNode) {
        if (
          event.target.parentNode.children &&
          event.target.parentNode.children[1]
        ) {
          const allElements = document.querySelectorAll(".dropdown-menu");
          allElements.forEach((element) => {
            // here sub-menu is an exception, so we handled it differently
            if (
              event.target.classList &&
              event.target.classList[0] !== "sub-menu"
            ) {
              element.classList.remove("show");
            }
          });

          event.target.parentNode.children[1].classList.add("show");
        }
      }
    } else {
      const naviBar = document.getElementById("navigBar");
      if (!naviBar.contains(event.target)) {
        const allElements = document.querySelectorAll(".dropdown-menu");
        allElements.forEach((element) => {
          element.classList.remove("show");
        });
      }
      const navB = document.getElementById("navbar-anchorId");
      if (navB.contains(event.target)) {
        const allElements = document.querySelectorAll(".dropdown-menu");
        allElements.forEach((element) => {
          element.classList.remove("show");
        });
      }
    }
  };

  return (
    <>
      <div className="skip-nav visually-hidden-focusable overflow-hidden">
        <div className="container-xl">
          <a
            className="d-inline-flex p-2 m-1"
            href={`#${skipToSection}`}
            tabIndex="0"
          >
            Skip to main content
          </a>
        </div>
      </div>
      <div className="header-box">
        <div className="header-logo">
          <div className="container">
            <div className="row brand-logo pt-4 g-0 align-items-center">
              <div className="col-lg-4">
                <div className="brand-logo">
                  <a href={`${process.env.GATSBY_BASE_URL}/${navUrls.Home}`}>
                    {isAssestPrefix ? (
                      <img
                        className="header-logo-img"
                        src={`${withAssetPrefix("/homeserve-logo.svg")}`}
                        alt="HomeServe logo"
                      />
                    ) : (
                      <img
                        className="header-logo-img"
                        src={HSLogo}
                        alt="HomeServe logo"
                      />
                    )}
                  </a>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="d-flex justify-content-end">
                  {showAccessibilityToolbar &&
                    <div>
                      <a href="#reciteme-launch" className="btn btn-hollow">
                        Accessibility Toolbar
                      </a>
                    </div>
                  }
                  {showCountrySelector && <div className="change-country">
                    {/* New accessible country selector */}
                    <button
                      type="button"
                      className="btn hidden-xs hidden-sm country-choose-btn country-chooser-parent btn-shared-nav"
                      data-toggle="dropdown"
                      id="selectCountry"
                    >
                      {isAssestPrefix ? (
                        <>
                          <img
                            src={`${withAssetPrefix("/flag-uk.png")}`}
                            alt="UK flag"
                            className="country-default-img"
                          />{" "}
                          UK
                        </>
                      ) : (
                        <>
                          <img
                            src={FlagUK}
                            alt="UK flag"
                            className="country-default-img"
                          />{" "}
                          UK
                        </>
                      )}
                      <span className="caret-icon" id="caretIcon"></span>
                    </button>
                    <ul
                      id="selectCountrySubmenu"
                      className="d-none country-chooser"
                    >
                      <li>
                        <a href="https://www.homeserve.com/en-us/">
                          {isAssestPrefix ? (
                            <span>
                              <img
                                src={`${withAssetPrefix("/flag-usa.jpg")}`}
                                alt="USA flag"
                              />{" "}
                              HomeServe USA
                            </span>
                          ) : (
                            <span>
                              <img src={FlagUSA} alt="USA flag" /> HomeServe USA
                            </span>
                          )}
                        </a>
                      </li>
                      <li>
                        <a href="https://www.homeserve.ca/">
                          {isAssestPrefix ? (
                            <span>
                              <img
                                src={`${withAssetPrefix("/flag-canada.jpg")}`}
                                alt="Canadian flag"
                              />{" "}
                              HomeServe Canada
                            </span>
                          ) : (
                            <span>
                              <img src={FlagCanada} alt="Canadian flag" />{" "}
                              HomeServe Canada
                            </span>
                          )}
                        </a>
                      </li>
                      <li>
                        <a href="https://www.homeserve.es/">
                          {isAssestPrefix ? (
                            <span>
                              <img
                                src={`${withAssetPrefix("/flag-spain.jpg")}`}
                                alt="Spanish flag"
                              />{" "}
                              HomeServe Spain
                            </span>
                          ) : (
                            <span>
                              <img src={FlagSpain} alt="Spanish flag" />{" "}
                              HomeServe Spain
                            </span>
                          )}
                        </a>
                      </li>
                      <li>
                        <a href="https://www.homeserve.fr/">
                          {isAssestPrefix ? (
                            <span>
                              <img
                                src={`${withAssetPrefix("/flag-france.jpg")}`}
                                alt="French flag"
                              />{" "}
                              HomeServe France
                            </span>
                          ) : (
                            <span>
                              <img src={FlagFrance} alt="French flag" />{" "}
                              HomeServe France
                            </span>
                          )}
                        </a>
                      </li>
                    </ul>
                  </div>
                  }
                  <div>
                    <a
                      href={`${process.env.GATSBY_BASE_URL}/${navUrls["claims"]}`}
                      className="btn btn-secondary btn-claim btn-shared-nav"
                    >
                      Make a claim
                    </a>
                    <a
                      href={`${process.env.GATSBY_BASE_URL}/${navUrls["My-homeserve"]}`}
                      className="btn btn-secondary btn-login btn-shared-nav"
                    >
                      Login
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="navigation-bar" ref={navBarRef}>
          <div className="container">
            <div className="row">
              <nav
                className="navbar navbar-expand-lg navi-bar"
                id="navigBar"
                aria-label="main menu"
              >
                <div className="container-fluid">
                  <a
                    className="navbar-brand navbar-anchor"
                    id="navbar-anchorId"
                    href={`${process.env.GATSBY_BASE_URL}/${navUrls.Home}`}
                  >
                    {isAssestPrefix ? (
                      <>
                        <img
                          className="nav-logo-desktop"
                          src={`${withAssetPrefix("/home-icon.png")}`}
                          alt="Home"
                        />
                        <img
                          className="nav-logo-mobile"
                          src={`${withAssetPrefix("/hs-logo-inline.png")}`}
                          alt="Home"
                        />
                      </>
                    ) : (
                      <>
                        <img
                          className="nav-logo-desktop"
                          src={HomeIcon1}
                          alt="Home"
                        />
                        <img
                          className="nav-logo-mobile"
                          src={HomeIcon2}
                          alt="Home"
                        />
                      </>
                    )}
                  </a>
                  {(isMobile || deviceWidth < 992) && (
                    <button
                      className={`navbar-toggler nav-toggle-btn ${isMobNavOpen ? 'showButtonHighlight' : 'hideButtonHighlight'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#offcanvasDarkNavbar"
                      role="button"
                      tabIndex="0"
                      aria-label="responsive menu toggle button"
                      onClick={() => setIsMobNavOpen(!isMobNavOpen)}
                    >
                      <span className="hs-icon hs-icon-white">
                        <i aria-hidden="true" className="icon-hs-nav-bars"></i>
                      </span>
                    </button>
                  )}
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" id="ddMenu">
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Home Cover
                        </a>
                        <ul className="dropdown-menu drop-down-multilevel">
                          <li className="d-flex drop-down-wrapper">
                            <ul>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Products and services"]}`}
                                >
                                  Products & services
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Boiler cover"]}`}
                                >
                                  Gas boiler cover
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Plumbing and drainage cover"]}`}
                                >
                                  Plumbing & drainage cover
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Electrics"]}`}
                                >
                                  Electrics cover
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Premium cover"]}`}
                                >
                                  HomeServe Premium cover
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Landlord boiler and plumbing cover"]}`}
                                >
                                  Landlord boiler & plumbing cover
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Home Accident Cover"]}`}
                                >
                                  Home accident cover
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Offers"]}`}
                                >
                                  Offers
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Home Installation
                        </a>
                        <ul className="dropdown-menu drop-down-multilevel">
                          <li className="d-flex drop-down-wrapper">
                            <ul>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Boiler install"]}`}
                                >
                                  Boiler install
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Electric car charger installations"]}`}
                                >
                                  EV charger installation
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Service Plans
                        </a>
                        <ul className="dropdown-menu drop-down-multilevel">
                          <li className="d-flex drop-down-wrapper">
                            <ul>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Boiler Service"]}`}
                                >
                                  Boiler service plans
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Heat pump service plan"]}`}
                                >
                                  Heat pump service plans
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Repairs
                        </a>
                        <ul className="dropdown-menu drop-down-multilevel">
                          <li className="d-flex drop-down-wrapper">
                            <ul>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Repairs and services"]}`}
                                >
                                  Repairs
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["I want to fix it myself"]}`}
                                >
                                  I want to fix it myself
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Help & Support
                        </a>
                        <ul className="dropdown-menu drop-down-multilevel">
                          <li className="d-flex drop-down-wrapper">
                            <ul>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["I have an issue"]}`}
                                >
                                  I have an issue
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["I am a customer and need to claim"]}`}
                                >
                                  I'm a customer and need to claim
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["I am not a customer and need to claim"]}`}
                                >
                                  I'm not a customer and need a repair
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Living - For your home"]}`}
                                >
                                  Knowledge Hub
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["FAQ"]}`}
                                >
                                  Frequently asked questions
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-link"
                                  href={`${process.env.GATSBY_BASE_URL}/${navUrls["Why trust HomeServe"]}`}
                                >
                                  Why trust HomeServe?
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <a
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Contact us"]}`}
                          className="nav-link contact-us-link"
                        >
                          Contact Us
                        </a>
                        <ul className="dropdown-menu drop-down-multilevel emptyUl"></ul>
                      </li>
                    </ul>
                    <form
                      // action={`${process.env.GATSBY_BASE_URL}/search`}
                      {...(cludoSearchEnabled ? {} : { action: `${process.env.GATSBY_BASE_URL}/search` })}
                      {...(cludoSearchEnabled ? { id: 'cludo-search-form' } : {})}
                      className="d-flex search-pad"
                      role="search"
                    >
                      <div className="search-field-parent">
                        <input
                          className="form-control search-field"
                          name="q"
                          type="text"
                          placeholder="Search"
                          aria-label="Search"
                        />
                        <button
                          type="submit"
                          className="icon-search"
                          value=""
                          aria-label="search"
                        >
                          {isAssestPrefix ? (
                            <img
                              src={`${withAssetPrefix("/search-icon.png")}`}
                              alt="search"
                            />
                          ) : (
                            <img src={SearchIcon} alt="search" />
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        {/* off canvas example */}
        {(isMobile || deviceWidth < 992) && (
          <div
            className="offcanvas offcanvas-start d-xl-none off-canvas-nav"
            tabIndex="-1"
            id="offcanvasDarkNavbar"
            aria-labelledby="offcanvasDarkNavbar"
            data-bs-backdrop="false"
            ref={offcanvasRef}
          >
            <div className="offcanvas-body">
              <div className="canvas-search-container">
                <form
                  // action={`${process.env.GATSBY_BASE_URL}/search`}
                  {...(cludoSearchEnabled ? {} : { action: `${process.env.GATSBY_BASE_URL}/search` })}
                  {...(cludoSearchEnabled ? { id: 'cludo-search-form-mobile' } : {})}
                  role="search"
                >
                  <div className="search-field-parent">
                    <input
                      className="form-control search-field"
                      name="q"
                      type="text"
                      placeholder="Search"
                      aria-label="Search"
                    />
                    <button
                      type="submit"
                      className="icon-search"
                      value=""
                      aria-label="search"
                    >
                      {isAssestPrefix ? (
                        <img
                          className="icon-search-img"
                          src={`${withAssetPrefix("/search-icon.png")}`}
                          alt=""
                        />
                      ) : (
                        <img
                          className="icon-search-img"
                          src={SearchIcon}
                          alt=""
                        />
                      )}
                    </button>
                  </div>
                </form>
              </div>
              <div>
                <ul className="navbar-nav" id="ddCanvasMenu">
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle canvas-navi-link rotate45"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Home Cover
                    </a>
                    <ul className="dropdown-menu canvas-drop-down-multilevel">
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Products and services"]}`}
                        >
                          Products & services
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Boiler cover"]}`}
                        >
                          Gas boiler cover
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Plumbing and drainage cover"]}`}
                        >
                          Plumbing & drainage cover
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Electrics"]}`}
                        >
                          Electrics cover
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Premium cover"]}`}
                        >
                          HomeServe Premium cover
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Landlord boiler and plumbing cover"]}`}
                        >
                          Landlord boiler & plumbing cover
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Home Accident Cover"]}`}
                        >
                          Home accident cover
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Offers"]}`}
                        >
                          Offers
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle canvas-navi-link rotate45"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Home Installation
                    </a>
                    <ul className="dropdown-menu canvas-drop-down-multilevel">
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Boiler install"]}`}
                        >
                          Boiler install
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Electric car charger installations"]}`}
                        >
                          EV charger installation
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle canvas-navi-link rotate45"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Service Plans
                    </a>
                    <ul className="dropdown-menu canvas-drop-down-multilevel">
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Boiler Service"]}`}
                        >
                          Boiler service plans
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Heat pump service plan"]}`}
                        >
                          Heat pump service plans
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle canvas-navi-link rotate45"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Repairs
                    </a>
                    <ul className="dropdown-menu canvas-drop-down-multilevel">
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Repairs and services"]}`}
                        >
                          Repairs
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["I want to fix it myself"]}`}
                        >
                          I want to fix it myself
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle canvas-navi-link rotate45"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Help & Support
                    </a>
                    <ul className="dropdown-menu canvas-drop-down-multilevel">
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["I have an issue"]}`}
                        >
                          I have an issue
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["I am a customer and need to claim"]}`}
                        >
                          I'm a customer and need to claim
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["I am not a customer and need to claim"]}`}
                        >
                          I'm not a customer and need a repair
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Living - For your home"]}`}
                        >
                          Knowledge Hub
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["FAQ"]}`}
                        >
                          Frequently asked questions
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item canvas-dropdown-item-link rotate45"
                          href={`${process.env.GATSBY_BASE_URL}/${navUrls["Why trust HomeServe"]}`}
                        >
                          Why trust HomeServe?
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link dropdown-toggle canvas-navi-link rotate45 contact-us-link"
                      href={`${process.env.GATSBY_BASE_URL}/${navUrls["Contact us"]}`}
                    >
                      Contact Us
                    </a>
                  </li>
                  {showAccessibilityToolbar &&
                    <li className="nav-item">
                      <a
                        className="nav-link dropdown-toggle canvas-navi-link rotate45 contact-us-link"
                        href="#reciteme-launch"
                      >
                        Accessibility Toolbar
                      </a>
                    </li>
                  }
                </ul>
              </div>
              <div className="canvas-nav-icon-container">
                <ul className="canvas-nav-icon">
                  <li>
                    <a
                      className="color-black"
                      href={`${process.env.GATSBY_BASE_URL}/${navUrls["My-homeserve"]}`}
                    >
                      <span className="hs-icon color-red">
                        <i aria-hidden="true" className="icon-hs-customer"></i>
                      </span>
                      Log in/register
                    </a>
                  </li>
                  <li>
                    <a
                      className="color-black"
                      href={`${process.env.GATSBY_BASE_URL}/${navUrls["claims"]}`}
                    >
                      <span className="hs-icon color-red">
                        <i aria-hidden="true" className="icon-hs-claim2"></i>
                      </span>
                      Make a claim
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
